"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.chatMessageDeserializeWithoutId = exports.chatMessageDeserialize = void 0;
const unwrap_1 = __importDefault(require("../util/unwrap"));
const ChatRecipientType_1 = require("./ChatRecipientType");
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const DatabaseTimestamp_1 = require("./firebase/DatabaseTimestamp");
function chatMessageDeserialize(value, id) {
    return Object.assign({ id: (0, deserializeString_1.deserializeString)(id) }, chatMessageDeserializeWithoutId(value));
}
exports.chatMessageDeserialize = chatMessageDeserialize;
function chatMessageDeserializeWithoutId(value) {
    const object = (0, deserializeObject_1.default)(value, 'chat message');
    return {
        body: (0, deserializeString_1.deserializeString)(object.body),
        recipientId: (0, deserializeString_1.deserializeString)(object.recipientId),
        recipientType: (0, ChatRecipientType_1.chatRecipientTypeDeserialize)(object.recipientType),
        seenBy: (0, unwrap_1.default)(object.seenBy, (0, deserializeArray_1.default)(deserializeString_1.deserializeString)),
        senderId: (0, deserializeString_1.deserializeString)(object.senderId),
        senderType: (0, ChatRecipientType_1.chatRecipientTypeDeserialize)(object.senderType),
        sentAt: (0, DatabaseTimestamp_1.databaseTimestampDeserialize)(object.sentAt),
    };
}
exports.chatMessageDeserializeWithoutId = chatMessageDeserializeWithoutId;
